import React, { Component } from 'react';

class FloatToTopButton extends Component {

  constructor(props) {
    super(props);
    this.state = { showButton: false };
    window.addEventListener('scroll', this.handlePageScroll);
  }

  /**
   * The minimum number of pixels from the top of the page for the floating button to appear.
   */

  SCROLL_THRESHOLD = 200;

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handlePageScroll);
  }

  handlePageScroll = () => {
    this.setState({ showButton: window.scrollY > this.SCROLL_THRESHOLD });
  }

  handleButtonClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth', });
  };

  render() {
    return (
      <div id='floating-button'>
        {this.state.showButton && (
          <button onClick={this.handleButtonClick} className="btn btn-floating">
            <i className="fa fa-angle-up fa-2x"/>
          </button>
        )}
      </div>
    );
  }
}

export default FloatToTopButton;



// WEBPACK FOOTER //
// ./src/components/common/FloatToTopButton.js